import type {
  CommunityFull,
  CommunityRestricted,
  CommunityRolePreview,
  CommunitySignUpRequest as ApiCommunitySignUpRequest,
  Organisation as ApiOrganisation,
  PermsGroupingsEnum,
  User as ApiUser,
  WebHook,
} from "@outverse-video/outverse-api-client-lib";

type UserFields =
  | "name"
  | "uuid"
  | "profileImage"
  | "handle"
  | "roles"
  | "profileColor"
  | "joinedCommunityAt"
  | "headline";
export type User = Pick<ApiUser, UserFields>;

export interface Member extends User {
  handleLower: string;
  isTeam: boolean;
  email?: string;
}

type communityFields =
  | "name"
  | "logoImage"
  | "coverImage"
  | "about"
  | "isPrivate"
  | "slug"
  | "isExternalLinkShown"
  | "externalLinkTag"
  | "externalLinkUrl"
  | "externalLinkImage"
  | "isExternalLink2Shown"
  | "externalLink2Tag"
  | "externalLink2Url"
  | "externalLink2Image"
  | "isExternalLink3Shown"
  | "externalLink3Tag"
  | "externalLink3Url"
  | "externalLink3Image"
  | "isCommunityEnabled"
  | "communitySectionName"
  | "isContentLibraryEnabled"
  | "contentLibraryTitle"
  | "primaryColor"
  | "memberCount"
  | "isMemberDirectoryShown"
  | "isDocumentsEnabled"
  | "flags"
  | "documentsName"
  | "docsVisible"
  | "isForumsFullWidth"
  | "isSemanticRelationShown"
  | "isDocMetadataShown"
  | "indexable"
  | "gtmId"
  | "changelogVisible"
  | "isChangelogEnabled"
  | "isChangelogExpanded"
  | "isAskAiTeamOnly"
  | "changelogDescription"
  | "widgetAccentColor"
  | "widgetAgentName"
  | "widgetLogo"
  | "widgetButtonText"
  | "backgroundColorDark"
  | "widgetCustomActionPrompt"
  | "widgetCustomActionLabel"
  | "widgetFooter"
  | "zendeskSubdomain";

export interface FullAccessCommunity extends Pick<CommunityFull, communityFields> {
  accessType: "full" | "restricted";
}

export type RestrictedAccessCommunity = Pick<CommunityRestricted, communityFields>;
export type Community = FullAccessCommunity | RestrictedAccessCommunity;
export type Organisation = Pick<ApiOrganisation, "uuid" | "logoImage">;
export type CommunitySignUpRequest = ApiCommunitySignUpRequest;

export interface Role {
  uuid: string;
  name: string;
  color: string;
  created: string;
  permsGroupings: Array<PermsGroupingsEnum>;
  users: Array<User>;
  usersCount: number;
  isCommunityMembers: boolean;
  isCommunityAdmins: boolean;
  isCommunityTeam: boolean;
}

export function rolePreview(role: Role): CommunityRolePreview {
  return {
    uuid: role.uuid,
    name: role.name,
    color: role.color,
    isMembers: role.isCommunityMembers,
    isAdmins: role.isCommunityAdmins,
    isTeam: role.isCommunityTeam,
  };
}

export type WebHookFormData = Omit<WebHook, "uuid" | "created">;

export const Privacy = {
  Public: "public",
  Private: "private",
  Open: "open",
};
